export default "__VITE_ASSET__BYQhEGJ___"